<template>
  <el-dialog :visible.sync="show" title="选择需要切换服务的聚能谷站点" :before-close="closeDialog" width="1200px">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="名称">
        <el-input placeholder="请输入名称" v-model="name" clearable></el-input>
      </el-form-item>
      <el-form-item label="区县">
        <el-input placeholder="请输入区/县" v-model="region" clearable></el-input>
      </el-form-item>
      <el-form-item label="站点模式">
        <el-input placeholder="请输入站点模式" v-model="buildTypeName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="getData()">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>
    <el-table border v-loading="loading" :data="tableData" highlight-current-row @current-change="handleDataChange" @selection-change="handleSelectionChange" header-cell-class-name="table-header-cell">
      <!-- <el-table-column label="选择" width="65" align="center">
        <template slot-scope="{ row }">
          <el-radio v-model="selectedId" :label="row.Id"><span></span></el-radio>
        </template>
      </el-table-column> -->
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column label="站点名称" prop="Name"></el-table-column>
      <el-table-column label="地址" prop="">
        <template slot-scope="{ row }">
          {{ row.Raddess }}
        </template>
      </el-table-column>
      <el-table-column label="区县" prop="ParentName" width="80"></el-table-column>
      <el-table-column label="数量" prop="dev_num" width="60"></el-table-column>

      <el-table-column label="站点类型" prop="IsVipStation" width="100px">
        <template slot-scope="{ row }">
          <el-tag type="danger" effect="dark" v-if="row.IsVipStation == 1">VIP站点</el-tag>
          <el-tag v-if="row.IsVipStation == 0">普通站点</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="项目编号" prop="projectNum" width="160px"></el-table-column> -->
      <el-table-column label="站点模式" prop="buildTypeName" width="90"></el-table-column>
      <el-table-column label="创建时间" prop="CreateTime" width="160px"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="{ row }">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="设备软件版本">
              <span v-html="row.params_text" class="tab-5"></span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>
    <div class="my-pagination">
      <el-pagination background layout="total,prev,pager,next" :total="pageParams.total" :page-size="pageParams.limit" :page-sizes="[10, 20, 30, 40, 50]" :current-page="pageParams.page" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <span slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button @click="comfirmDialog" type="primary">确定并关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import "@/styles/style_switch_device.css"

import { GetOrgForIpSPageList } from "@/api/dev_archive"
import pageMixin from "@/mixins/cptMixin.js"
export default {
  mixins: [pageMixin],
  data() {
    return {
      loading: false,
      tableData: [],
      multipleSelection: [],
      typename: "",
      is_tjtf: "",
      selectItem: "",
      name: "",
      region: "",
      buildTypeName: "",
      pageParams: {
        page: 1,
        limit: 10,
        total: 0
      },
      selectedId: ""
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    deviceType: {
      type: [String, Number],
      default: ""
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.typename = this.deviceType
        //this.getData()
      } else {
        this.selectItem = ""
        this.selectedId = ""
      }
    }
  },
  methods: {
    comfirmDialog() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message.error("请先选择数据")
        return
      }
      this.$emit("confirm", this.multipleSelection)
    },
    comfirmDialog_old() {
      if (!this.selectItem) {
        this.$message.error("请先选择数据")
        return
      }
      this.$emit("confirm", this.selectItem)
    },
    getData() {
      this.loading = true

      if (this.typename == "1") {
        this.is_tjtf = 1
        this.typename = ""
      }
      GetOrgForIpSPageList({
        page: this.pageParams.page,
        limit: this.pageParams.limit,
        typename: this.typename,
        name: this.name,
        region: this.region,
        buildTypeName: this.buildTypeName,
        is_tjtf: this.is_tjtf
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = Number(res.total)
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeDialog() {
      this.$emit("update:show", false)
    },
    handleDataChange(val) {
      console.log("handleDataChange", val)
      if (val) {
        this.selectedId = val.Id
        this.selectItem = val
      }
    },
    handleSelectionChange(val) {
      console.log("handleSelectionChange", val)
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-table-expand {
  margin: 0 16px;
}
</style>
